export default __webpack_public_path__ + "static/media/expo.8230c001.svg";